import a from "react";
import o from "classnames";
import e from "./index77.mjs";
const l = ({ isShow: t }) => /* @__PURE__ */ a.createElement(
  "div",
  {
    "data-testid": "overlay",
    className: o(e.overlay, {
      [e.show]: t
    })
  }
);
export {
  l as Overlay
};
